import { css } from '@emotion/react'

const aiWrapper = theme => css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  backdrop-filter: blur(2px);
  background-color: rgba(${theme.color.monochrome.white_rgba}, 0.8);

  > div {
    height: auto;
    background-color: transparent;
  }
`

const isNote = () => css`
  /* FIXME (jscheel): Need to update theme to include rgb versions */
  background-color: rgba(253, 248, 230, 0.8);
`

export const styles = {
  aiWrapper,
  isNote,
}
